module.exports = __webpack_public_path__ + "img/background.aad70992.png";